export const energySourceLabelMap = {
  coal: 'Coal',
  gas: 'Natural Gas',
  nuclear: 'Nuclear',
  oil: 'Oil',
  other: 'Other',
  renewables: 'Renewables',
};
